"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./KdbTrendUtils";

export default function KdbThreeColSection({ title, items, width = "ods-50" }) {
  return (
    <div className={`kdb-ods-detail-item kbv-hbet-odt-card ${width}`}>
      <div className="kdb-odstb-title kbv-hbet-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="kdb-odstb-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="kdb-title-odds">{item.label}</div>
            <div
              className={`kdb-odds kbv-hbet-odt-odds ods-100 kdb-ods-white ${trendClass(
                item.trend,
              )}`}
            >
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
